module.exports = __webpack_public_path__ + "img/knight4cf_04.0095af21.jpg";